import { createCodedError } from '~/common/errors/CodedError';
import { EsignatureType } from '~/enums/EsignatureType';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { everest } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

type Request = {
  ticketId: Uuid;
  vendor: EsignatureType;
  returnUrl: string;
  viewMode?: 'correct';
};

type ServerRequest = {
  vendor: string;
  returnUrl: string;
  viewMode?: 'correct';
};

type Response = {
  redirectUrl: string;
};

type ServerResponse = {
  type: string;
  id: string;
  links: {
    console_view: string;
  };
};

export const viewEnvelope = async (request: Request): Promise<Response> => {
  try {
    const response: ServerResponse = await everest.post(
      `/tickets/${request.ticketId}/packages/view`,
      mapRequest(request),
    );

    return mapResponse(response);
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors[0];
      throw createCodedError({
        message: errorResponse.detail ?? errorResponse.title,
        statusCode: errorResponse.status,
        title: errorResponse.title,
      });
    }

    throw error;
  }
};

const mapRequest = (request: Request): ServerRequest => {
  return {
    vendor: request.vendor.toUpperCase(),
    returnUrl: request.returnUrl,
    ...(request.viewMode ? { viewMode: request.viewMode } : {}),
  };
};

const mapResponse = (serverResponse: ServerResponse): Response => {
  return {
    redirectUrl: serverResponse.links.console_view,
  };
};
